export type KnowledgeBaseDoc = {
  slug: string;
  title: string;
  section: string;
  summary: string;
  publicPath: string;
};

export const knowledgeBaseDocs: KnowledgeBaseDoc[] = [
  {
    slug: "integrations/installing-quake-mcp",
    title: "Install Quake MCP",
    section: "Integrations",
    summary: "Connect Quake MCP to ChatGPT, Claude, Codex CLI, or Claude Code CLI with delegated OAuth access.",
    publicPath: "/docs/integrations/installing-quake-mcp.md",
  },
  {
    slug: "openapi/delegated-openapi-sessions",
    title: "Delegated OpenAPI Sessions",
    section: "OpenAPI",
    summary:
      "How delegated OAuth sessions work, what they require, and how external systems should integrate with them.",
    publicPath: "/docs/openapi/delegated-openapi-sessions.md",
  },
  {
    slug: "candidates/document-parsing-and-resume-intake",
    title: "Document Parsing and Resume Intake",
    section: "Candidates",
    summary: "How Quake Platform accepts, classifies, parses, and applies resume documents in candidate workflows.",
    publicPath: "/docs/candidates/document-parsing-and-resume-intake.md",
  },
  {
    slug: "ai-chats/customizing-quake-ai-chats",
    title: "Customizing Quake Chats",
    section: "AI Chats",
    summary: "How agent instructions, personalization, sharing, @ context, and file uploads shape chat behavior.",
    publicPath: "/docs/ai-chats/customizing-quake-ai-chats.md",
  },
  {
    slug: "ownership-model/client-and-contact-ownership",
    title: "Client and Contact Ownership",
    section: "Ownership Model",
    summary: "How ownership, visibility, and client-contact inheritance work inside Fusion.",
    publicPath: "/docs/ownership-model/client-and-contact-ownership.md",
  },
];

export function normalizeKnowledgeBaseSlug(slug?: string | null) {
  if (!slug) return "";
  return slug.replace(/^\/+|\/+$/g, "");
}

export function getKnowledgeBaseDocBySlug(slug?: string | null) {
  const normalizedSlug = normalizeKnowledgeBaseSlug(slug);
  return knowledgeBaseDocs.find((doc) => doc.slug === normalizedSlug) ?? null;
}

export function groupKnowledgeBaseDocs(docs: KnowledgeBaseDoc[]) {
  return docs.reduce<Record<string, KnowledgeBaseDoc[]>>((groups, doc) => {
    const sectionDocs = (groups[doc.section] ??= []);
    sectionDocs.push(doc);
    return groups;
  }, {});
}
